import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Link.module.sass';

const NewLink = ({
  label,
  to,
  style,
  className
}) => {
  return /*#__PURE__*/React.createElement(Link, {
    className: `${styles['link']} ${className || ''}`,
    to: to || '#',
    style: style
  }, /*#__PURE__*/React.createElement("small", null, label));
};

export default NewLink;